module.exports = __webpack_public_path__ + "media/images/gift-4-fa3c0b76b034706a6b22b299904956bf.svg";